import { Construtor } from './construtor';
import { Indicador } from './indicador';
import { PontoFisicoParametroGrafico } from './ponto-fisico-parametro-grafico';
import { TipoPontoFisicoParametroGrafico } from './tipo-ponto-fisico-parametro-grafico';
import { RegiaoParametroGrafico } from './regiao-parametro-grafico';
import { UsuarioParametroGrafico } from './usuario-parametro-grafico';
import { AreaParametroGrafico } from './area-parametro-grafico';

export class ParametroGrafico implements Construtor<ParametroGrafico> {

  public idParametroGrafico: number;
  public idDashboard: number;
  public tipoGrafico: string;
  public posicaoGrafico: number;
  public tamanhoColuna: number;
  public pontosFisicosParametroGrafico: PontoFisicoParametroGrafico[];
  public indicador: Indicador;
  public tiposPontoFisicoParametroGrafico: TipoPontoFisicoParametroGrafico[];
  public regioesParametroGrafico: RegiaoParametroGrafico[];
  public areasParametroGrafico: AreaParametroGrafico[];
  public legenda: boolean;
  public diasAte: number;
  public semanasAte: number;
  public mesesAte: number;
  public anosAte: number;
  public periodicidadeDados: number;
  public dataInicioReferencia: Date;
  public dataFimReferencia: Date;
  public descricaoTipoPontoFisico: string;
  public meta: boolean;
  public usuariosParametroGrafico: UsuarioParametroGrafico[];
  public view: number[];

  constructor(object?: any) {

    this.indicador = new Indicador();
    this.view = new Array<number>();
    this.usuariosParametroGrafico = new Array<UsuarioParametroGrafico>();
    this.pontosFisicosParametroGrafico = new Array<PontoFisicoParametroGrafico>();
    this.tiposPontoFisicoParametroGrafico = new Array<TipoPontoFisicoParametroGrafico>();
    this.regioesParametroGrafico = new Array<RegiaoParametroGrafico>();
    this.areasParametroGrafico = new Array<AreaParametroGrafico>();

    if (object !== undefined) {

      if (object instanceof ParametroGrafico) {
        this.copyObject(object);
      } else if (object instanceof (Indicador)) {
        this.indicador = object;
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }
    }

    return this;
  }

  copyObject(parametro: ParametroGrafico): void {
    this.idParametroGrafico = parametro.idParametroGrafico;
    this.idDashboard = parametro.idDashboard;
    this.tipoGrafico = parametro.tipoGrafico;
    this.posicaoGrafico = parametro.posicaoGrafico;
    this.tamanhoColuna = parametro.tamanhoColuna;
    this.pontosFisicosParametroGrafico = parametro.pontosFisicosParametroGrafico;
    this.indicador = parametro.indicador;
    this.tiposPontoFisicoParametroGrafico = parametro.tiposPontoFisicoParametroGrafico;
    this.regioesParametroGrafico = parametro.regioesParametroGrafico;
    this.areasParametroGrafico = parametro.areasParametroGrafico;
    this.legenda = parametro.legenda;
    this.diasAte = parametro.diasAte;
    this.mesesAte = parametro.mesesAte;
    this.semanasAte = parametro.semanasAte;
    this.anosAte = parametro.anosAte;
    this.periodicidadeDados = parametro.periodicidadeDados;
    this.dataInicioReferencia = parametro.dataInicioReferencia;
    this.dataFimReferencia = parametro.dataFimReferencia;
    this.descricaoTipoPontoFisico = parametro.descricaoTipoPontoFisico;
    this.meta = parametro.meta;
    this.usuariosParametroGrafico = parametro.usuariosParametroGrafico;
  }

  parseFromJson(parametro: any): void {
    this.idParametroGrafico = parametro.idParametroGrafico;
    this.idDashboard = parametro.idDashboard;
    this.tipoGrafico = parametro.tipoGrafico;
    this.posicaoGrafico = parametro.posicaoGrafico;
    this.tamanhoColuna = parametro.tamanhoColuna;
    this.indicador = parametro.indicador;
    this.tiposPontoFisicoParametroGrafico = parametro.tiposPontoFisicoParametroGrafico;
    this.pontosFisicosParametroGrafico = parametro.pontosFisicosParametroGrafico;
    this.regioesParametroGrafico = parametro.regioesParametroGrafico;
    this.areasParametroGrafico = parametro.areasParametroGrafico;
    this.legenda = parametro.legenda;
    this.diasAte = parametro.diasAte;
    this.mesesAte = parametro.mesesAte;
    this.semanasAte = parametro.semanasAte;
    this.anosAte = parametro.anosAte;
    this.periodicidadeDados = parametro.periodicidadeDados;
    this.dataInicioReferencia = parametro.dataInicioReferencia;
    this.dataFimReferencia = parametro.dataFimReferencia;
    this.descricaoTipoPontoFisico = parametro.descricaoTipoPontoFisico;
    this.meta = parametro.meta;
    this.usuariosParametroGrafico = parametro.usuariosParametroGrafico;
  }

  modeloCompleto(): boolean {
    return this.idDashboard !== undefined;
  }

  getNewInstance(object?: any): ParametroGrafico {
    return new ParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/parametro-grafico.ts